import React from "react";
import styles from "./LocationTableControls.module.css";
import {BroomButton} from "../../../../elements/broomButton/BroomButton";
import {SearchField} from "../../../../elements/searchField/SearchField";
import {
    MultiSelectTableFilterDropdown
} from "../../../../elements/multiSelectTableFilter/MultiSelectTableFilterDropdown";
import {TableFilterDropdown} from "../../../../elements/tableFilterDropdown/TableFilterDropdown";
import {useAppDispatch, useAppSelector} from "../../../../../app/hooks";
import {
    defaultLocationTableRequest,
    resetLocationTableRequest,
    locationTableRequestSelector,
    updateLocationTableRequest
} from "../../locationListSlice";
import {VehicleDataProvider} from "../../../../../api/generated";
import {SelectOption} from "../../../../elements/select/SelectDropdown";
import {getVehicleDataProviderTitle} from "../../../../../utils/enumValueTitleUtil";

export const LocationTableControls: React.FC = () => {

    const dispatch = useAppDispatch()
    const locationTableRequest = useAppSelector(locationTableRequestSelector)

    const getVehicleDataProviderOptions = (): SelectOption<VehicleDataProvider>[] => {
        return Object.values(VehicleDataProvider).map(provider => ({
            value: provider,
            label: getVehicleDataProviderTitle(provider)
        }))
    }

    const getAftersalesOptions = (): SelectOption<boolean | undefined>[] => {
        return [
            {value: undefined, label: "All"},
            {value: true, label: "Aftersales Enabled"},
            {value: false, label: "Aftersales Disabled"}
        ]
    }

    const resetFilters = () => {
        if (locationTableRequest.searchQuery !== defaultLocationTableRequest.searchQuery ||
            locationTableRequest.vehicleDataProviders !== defaultLocationTableRequest.vehicleDataProviders ||
            locationTableRequest.aftersalesEnabled !== defaultLocationTableRequest.aftersalesEnabled) {
            dispatch(resetLocationTableRequest())
        }
    }

    return <div className={styles.wrapper}>
        <div className={styles.controls}>
            <SearchField
                value={locationTableRequest.searchQuery}
                placeholder={'Search Name, City, Phone, Hash'}
                onChange={newValue => dispatch(updateLocationTableRequest({searchQuery: newValue}))}
            />
            <MultiSelectTableFilterDropdown<VehicleDataProvider, {}>
                value={locationTableRequest.vehicleDataProviders}
                placeholder={"Filter by Data Provider"}
                width={240}
                handleChange={(providers) => dispatch(updateLocationTableRequest({vehicleDataProviders: providers}))}
                options={getVehicleDataProviderOptions()}
            />
            <TableFilterDropdown<boolean | undefined>
                value={locationTableRequest.aftersalesEnabled}
                placeholder={"Filter by Aftersales"}
                width={240}
                handleChange={(aftersalesEnabled) => dispatch(updateLocationTableRequest({aftersalesEnabled}))}
                options={getAftersalesOptions()}
            />
        </div>
        <div className={styles.clearButton}>
            <BroomButton disabled={false} handleClick={resetFilters}/>
        </div>
    </div>
}
